import React, { FC } from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { Box, Grid, Heading } from '@chakra-ui/react'
import { RichButton } from 'src/uikit'
import { useSelectableDeposits } from 'src/utils/hooks'
import { formatWithVat } from 'src/utils/formatCurrency'

interface Props {
  offerData: OfferGlobal.RentOfferDetail
  mt?: string
}

const ChooseDeposit: FC<Props> = ({ offerData, mt }) => {
  const { t } = useTranslation()
  const priceVatIncluded = useSelector((state: Store.RootState) => state.nlt.priceVatIncluded)
  const { offer, selectableDeposits, hasDepositChoice, monthlyRateFromDeposit, selectVariationItem } =
    useSelectableDeposits(offerData)

  if (!hasDepositChoice) {
    return null
  }

  return (
    <Box mt={mt}>
      <Heading as="h3" fontSize="1.125rem" fontFamily="Montserrat-SemiBold" textAlign="left" mb="m">
        {t('nltCustomizeOfferModalStepsComponent:step0.chooseDeposit')}
      </Heading>

      <Grid templateColumns="repeat(auto-fit, minmax(min(17rem, 100%), 1fr))" gap="m">
        {selectableDeposits.map((deposit: any) => {
          const monthlyRate = monthlyRateFromDeposit(deposit)

          return (
            <RichButton
              key={deposit}
              onClick={() => selectVariationItem('deposit', deposit)}
              title={`${formatWithVat(deposit, priceVatIncluded)}€`}
              description={t('nltCustomizeOfferModalStepsComponent:ratePerMonth', {
                value: monthlyRate === null ? '- ' : formatWithVat(monthlyRate, priceVatIncluded),
              }).toString()}
              selected={deposit === offer.deposit && monthlyRate !== null}
              disabled={monthlyRate === null}
            />
          )
        })}
      </Grid>
    </Box>
  )
}

export default ChooseDeposit
